import Alert from "../components/Alert";

class Utils {
    static setCookie(name, value, hours) {
        let expires = '';
        if (hours) {
            let date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    static getCookie(name, _default) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return _default;
    }
    static removeCookie(name) {
        Utils.setCookie(name, '', -1);
    }
    static activateDockIcon($targetLink, callBack) {
        let $targetIcon = $targetLink.find('.icon-custom');
        $targetLink.removeClass('was-active').addClass('active');
        $targetIcon.removeClass($targetIcon.attr('data-inactive-class')).addClass($targetIcon.attr('data-active-class'));
        $targetLink.find('.title').fadeIn(300, null, function () {
            if(typeof callBack !== 'undefined') {
                callBack();
            }
        });
    }
    static animateDockIcons($targetLink, callBack) {
        let $currentActive = jQuery('.mobile-dock-nav').find('.active');
        if($currentActive.length > 0) {
            let $currentIcon = $currentActive.find('.icon-custom');
            $currentActive.removeClass('active').addClass('was-active');
            $currentIcon.removeClass($currentIcon.attr('data-active-class')).addClass($currentIcon.attr('data-inactive-class'));
            $currentActive.find('.title').fadeOut(300, null, function () {
                Utils.activateDockIcon($targetLink, callBack);
            });
        } else {
            Utils.activateDockIcon($targetLink, callBack);
        }
    }
    static setupFooter(){
        let $footer = jQuery('footer.footer');
        let $dockNav = jQuery('.mobile-dock-nav');
        if(jQuery(window).width() > 960){
            $footer.css('margin-bottom', '0');
            return false;
        }
        if($dockNav.length <= 0) {
            return false;
        }
        if($dockNav.find('.active').length > 0){
            $footer.css('margin-bottom', '52px');
        } else {
            $footer.css('margin-bottom', '40px');
        }
    }
    static initClipboard($wrapper, options) {
        if(typeof $wrapper === 'undefined'){
            $wrapper = jQuery(document.body);
        }
        options = (typeof options !== 'undefined')? options:{};
        $wrapper.find('[data-action="copy-link"]').each(function(){
            let clipboard = new ClipboardJS(this, options);
            clipboard.on('success', function() {
                Alert.showGeneralAlert('Copied!');
            });
            clipboard.on('error', function() {
                Alert.showGeneralAlert('Error with clipboard');
            });
        });
    }
    static isInViewport(elem) {
        let bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    static extractDomain(url, default_domain) {
        let domain;
        default_domain = default_domain || "crazyshit.com";
        if((url.indexOf("://") > -1) || (url.indexOf("//") == 0)) {
            domain = url.split("/")[2];
        } else if(url.indexOf("/") == 0) {
            domain = default_domain;
        } else {
            domain = url.split("/")[0];
        }
        domain = domain.split(":")[0];
        domain = domain.replace(/^www\./g, "");
        return domain;
    }
    static esc_attr(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    static esc_html(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static commit_ajax_action(ajax_action, data, on_success, on_error, on_complete) {
        if(!ajax_action) {
            return false;
        }
        let options = {
            'method': "POST",
            'url': "/ajax/"+ ajax_action +".php",
            'cache': false,
            'dataType': "json"
        };
        if(data) {
            options['data'] = data;
        }
        if(jQuery.isFunction(on_success)) {
            options['success'] = on_success;
        }
        if(jQuery.isFunction(on_error)) {
            options['error'] = on_error;
        }
        if(jQuery.isFunction(on_complete)) {
            options['complete'] = on_complete;
        }
        jQuery.ajax(options);
    };
    static showBodyOverlay(className) {
        let $overlay = jQuery('.body-overlay');
        if(typeof className !== 'undefined') {
            $overlay.addClass(className);
        }
        jQuery(document.body).addClass('modal-open');
        $overlay.fadeIn(300).attr('data-layers-count', parseInt($overlay.attr('data-layers-count')) + 1);
    };
    static hideBodyOverlay(className) {
        let $overlay = jQuery('.body-overlay');
        let layerCount = parseInt($overlay.attr('data-layers-count'));
        if(typeof className !== 'undefined') {
            $overlay.removeClass(className);
        }
        if(layerCount === 1) {
            jQuery(document.body).removeClass('modal-open');
            $overlay.fadeOut(300);
        }
        if(layerCount - 1 >= 0) {
            $overlay.attr('data-layers-count', layerCount - 1);
        }
    };
    static isSessionStorageSupported() {
        try {
            sessionStorage.setItem('_test_key', '_test_value');
            sessionStorage.removeItem('_test_key');
            return true;
        } catch (e) {
            return false;
        }
    }
    static pushToStorage(storageKey, value) {
        if(Utils.isSessionStorageSupported()){
            sessionStorage.setItem(storageKey, value);
        }
    }
    static getFromStorage(storageKey) {
        if(Utils.isSessionStorageSupported()){
            let item = sessionStorage.getItem(storageKey);
            return item? JSON.parse(item):[];
        }
        return false;
    }
    static removeFromStorage(storageKey) {
        if(Utils.isSessionStorageSupported()){
            sessionStorage.removeItem(storageKey);
        }
    }
    static initSelect2() {
        jQuery('[data-is-select2]').each(function () {
            let $select = jQuery(this);
            let perPageLimit = 10;
            let maxAllowed = 10;
            $select.select2({
                ajax: {
                    url: "/ajax/tags_search.php",
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            page: params.page
                        };
                    },
                    processResults: function (data, params) {
                        let results = [];
                        data.cargo.items.forEach(function (item) {
                            results.push({
                                'text': item.title,
                                'id': item.title
                            });
                        });
                        params.page = params.page || 1;
                        return {
                            results: results,
                            pagination: {
                                more: (params.page * perPageLimit) < data.cargo.total_count
                            }
                        };
                    },
                    cache: true
                },
                maximumSelectionLength: maxAllowed,
                placeholder: "Tags",
                theme: "classic",
                minimumInputLength: 2,
                tokenSeparators: [',', ', '],
                tags: true,
                createTag: function (params) {
                    let term = jQuery.trim(params.term);
                    if (term === '') {
                        return null;
                    }
                    return {
                        id: term,
                        text: term,
                        newTag: true
                    }
                }
            });
            $select.on("select2:select", function (event) {
                let element = event.params.data.element;
                let $el = jQuery(element);
                $el.detach();
                jQuery(this).append($el);
                jQuery(this).trigger("change");
            });
        });
    }
    static setupAutoExpandFields() {
        jQuery('[data-can-autoexpand]').each(function () {
            let $this = jQuery(this);
            if(!$this.hasClass('initialized')){
                jQuery(this).on('input, keyup', function(){
                    let paddingY = parseInt(jQuery(this).css('padding-top')) * 2;
                    jQuery(this).css('height', 'auto');
                    jQuery(this).css('height', (jQuery(this)[0].scrollHeight - paddingY) + "px");
                });
                $this.addClass('initialized');
            }
        });
    };
}

export default Utils;